import { mergeRight } from 'ramda'
import theme from '../../../../theme'

const color = {
  lightboxYellow: '#ffd500',
  neonPrimary: theme.neonPrimary,
  neonBlack: theme.field,
  black: '#000000',
  white: '#ffffff',
  rental: theme.neonPink,
  transparent: 'transparent'
}

const colorKids = mergeRight(color, {
  lightboxYellow: '#EFFE3E',
  neonPrimary: '#818A00',
  rental: '#818A00',
  black: color.white,
  white: color.black
})

export const getColor = isKid => {
  if (isKid) {
    return colorKids
  }

  return color
}

export default color
